import type { CmsGift, CmsProduct } from '../../types/cmsProduct';
import type { RewardGridCardPreviewItem } from './types';

export const getRewardGridCardValueText = ({
  gift,
  formatCurrency,
  formatNumber,
}: {
  gift?: CmsGift;
  formatCurrency: (currency?: string) => string;
  formatNumber: (value: number) => string;
}) => {
  const giftValue = gift?.gift_value;

  if (!giftValue?.price || !giftValue.prefix) {
    return undefined;
  }

  return `${formatCurrency(giftValue.prefix)}${formatNumber(giftValue.price)}`;
};

export const getRewardGridCardProductPreviewItems = ({
  products,
}: {
  products: CmsProduct[];
}): RewardGridCardPreviewItem[] =>
  products
    .map((product) => {
      const imageUrl =
        product.product_image || product.provider?.provider_image;

      if (!imageUrl && !product.product_name) {
        return null;
      }

      return {
        imageUrl: imageUrl || undefined,
        title: product.product_name ?? undefined,
      };
    })
    .filter((previewItem): previewItem is NonNullable<typeof previewItem> =>
      Boolean(previewItem),
    );
